<template>
    <div class="w-full mx-auto grid grid-cols-2 gap-4">
        <Link href="/admin/user" class="btn-menu w-full text-center text-xs md:text-md"> User </Link>
        <Link href="/admin/informasi" class="btn-menu w-full text-center text-xs md:text-md"> Informasi </Link>
        <Link href="/admin/jadwal_dokter" class="btn-menu w-full text-center text-xs md:text-md">
            Jadwal Dokter Dasar
        </Link>
        <Link href="/admin/jadwal_dokter_khusus" class="btn-menu w-full text-center text-xs md:text-md">
            Jadwal Dokter Khusus
        </Link>
        <Link href="/admin/pasien_igd" class="btn-menu w-full text-center text-xs md:text-md"> Pasien IGD </Link>
        <Link href="/admin/pasien_ranap" class="btn-menu w-full text-center text-xs md:text-md"> Pasien Ranap </Link>
        <Link href="/admin/bed_kosong" class="btn-menu w-full text-center text-xs md:text-md"> BED Kosong </Link>
        <Link href="/admin/pasien_pulang_ranap" class="btn-menu w-full text-center text-xs md:text-md"> Pasien Pulang Ranap </Link>
        <Link href="/admin/jadwal_dokter_admin" class="btn-menu w-full text-center text-xs md:text-md"> Jadwal Dokter </Link>
        <Link href="/admin/apotek_rajal" class="btn-menu w-full text-center text-xs md:text-md"> Apotek Rajal </Link>
        <Link href="/admin/apotek_ranap" class="btn-menu w-full text-center text-xs md:text-md"> Apotek Ranap </Link>
        <Link href="/admin/antrian_per_poli" class="btn-menu w-full text-center text-xs md:text-md"> Antrian Per Poliklinik </Link>
        <Link href="/admin/antrian_per_poli_detail" class="btn-menu w-full text-center text-xs md:text-md"> Antrian Per Poli Detail </Link>
        <Link href="/admin/antrian_total" class="btn-menu w-full text-center text-xs md:text-md"> Antrian Total </Link>
        <Link href="/admin/mod_dashboard" class="btn-menu w-full text-center text-xs md:text-md"> Mod Dashboard </Link>
        <Link href="/admin/pasien_pulang_igd" class="btn-menu w-full text-center text-xs md:text-md"> Pasien Pulang IGD </Link>
        <Link href="/admin/monitoring_pengadaan_obat" class="btn-menu w-full text-center text-xs md:text-md"> Monitoring Pengadaan Obat </Link>
        <Link href="/admin/pengadaan_obat_yang_lunas" class="btn-menu w-full text-center text-xs md:text-md"> Pengadaan Obat Yang Lunas </Link>
        <Link href="/admin/rekap_pasien_ibs" class="btn-menu w-full text-center text-xs md:text-md"> Rekap Pasien IBS </Link>
        <Link href="/admin/rekap_pasien_rajal" class="btn-menu w-full text-center text-xs md:text-md"> Rekap Pasien Rajal </Link>
        <!-- <Link href="/admin/defecta" class="btn-menu w-full text-center text-xs md:text-md"> DEFECTA </Link>
        <Link href="/admin/batch_ed_farmasi" class="btn-menu w-full text-center text-xs md:text-md"> BATCH ED FARMASI </Link> -->
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
export default {
    components: {
        Link,
    },
};
</script>
